'use client';
import { useState, useEffect, useCallback } from 'react';

function useDrag() {
  const [startY, setStartY] = useState(0);
  const [deltaY, setDeltaY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  function handleTouchStart(e: TouchEvent) {
    const touch = e.touches[0];
    setStartY(touch.clientY);
    setIsDragging(true);
  }

  const handleTouchMove = useCallback(
    (e: TouchEvent) => {
      if (!isDragging) return;
      const touch = e.touches[0];
      const moveY = touch.clientY;
      setDeltaY(moveY - startY);
    },
    [isDragging, startY],
  );

  function handleTouchEnd() {
    setIsDragging(false);
    setDeltaY(0);
  }

  useEffect(() => {
    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchMove]);

  return { deltaY, isDragging };
}

export default useDrag;
